import { render, staticRenderFns } from "./noodKenA.vue?vue&type=template&id=3c5233ed&scoped=true"
import script from "./noodKenA.vue?vue&type=script&lang=js"
export * from "./noodKenA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5233ed",
  null
  
)

export default component.exports